export default "__VITE_ASSET__CZIddB5x__"